




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Filter } from '@/models/Filter';

@Component
export default class FilterManageButton extends Vue {
    get activeFilter(): Filter | null {
        return this.$store.state.filters.activeFilter;
    }

    get config() {
        return this.$store.state.config;
    }

    get isLoggedIn(): boolean {
        return this.$store.state.isLoggedIn;
    }

    get favouriteCount(): number {
        return this.$store.state.favourites.favouriteCount;
    }

    get savedFilters() {
        return this.$store.state.filters.savedFilters;
    }

    get filterCount() {
        return this.$store.state.filters.filterCount;
    }

    public onManageFilters() {
        console.log('onManageFilters');
        if (this.isLoggedIn) {
            this.$store.dispatch('showFilterManager');
        } else {
            this.$store.dispatch('showLoginPromptDialog', 'You must login to view saved filters.');
        }
    }
}

